import { render, staticRenderFns } from "./CommonProps.vue?vue&type=template&id=3e572b10"
import script from "./CommonProps.vue?vue&type=script&lang=js"
export * from "./CommonProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports